import $ from "jquery";

/**
 * Read a query parameter from the URL
 * @param {string} name
 * @returns {string|false}
 */
function getUrlParameter(name) {
    const params = new URLSearchParams(window.location.search);
    return params.has(name) ? decodeURIComponent(params.get(name)) : false;
}

/**
 * Generic function to create cookies
 * @param {string} name
 * @param {string} value
 * @param {number} days
 * @param {object} [options]
 */
function setCookie(name, value, days, options = {}) {
    const { path = "/", domain = "", secure = true, sameSite = "Lax" } = options;
    const expires = days
        ? `; expires=${new Date(Date.now() + days * 864e5).toUTCString()}`
        : "";
    const domainPart = domain ? `; domain=${domain}` : "";
    const securePart = secure ? "; secure" : "";
    document.cookie = `${name}=${value}${expires}; path=${path}${domainPart}${securePart}; SameSite=${sameSite}`;
}

/**
 * Read cookie by name
 * @param {string} name
 * @returns {string}
 */
function getCookie(name) {
    const cookieMatch = document.cookie.match(`(?:^|; )${name}=([^;]*)`);
    return cookieMatch ? decodeURIComponent(cookieMatch[1]) : "";
}

/**
 * Delete cookie
 * @param {string} name
 */
function deleteCookie(name) {
    setCookie(name, "", -1);
}

/**
 * Consent-specific cookie setter
 */
function createConsentCookie(name, value, days) {
    const domain =
        ["localhost", "127.0.0.1"].includes(location.hostname)
            ? "localhost"
            : ".mastercraft.com";

    setCookie(name, value, days, { domain });
}

/**
 * Accept all cookies
 */
function addAllConsentCookies() {
    const consent = true;
    const keys = [
        "user_cookie_consent",
        "user_essential_cookie_consent",
        "user_performance_cookie_consent",
        "user_functional_cookie_consent",
        "user_social_media_cookie_consent",
    ];

    keys.forEach((key) => createConsentCookie(key, consent, 30));

    $("#performanceCookieSwitch, #functionalCookieSwitch, #socialmediaCookieSwitch").prop("checked", true);
    setGTMConsent();
    setEthiosConsent();
    hideCookieConsent();
    loadUTMParameters();
}

/**
 * Accept selected cookies
 */
function addCustomConsentCookies() {
    createConsentCookie("user_cookie_consent", true, 30);
    createConsentCookie("user_essential_cookie_consent", true, 30);
    createConsentCookie("user_performance_cookie_consent", $("#performanceCookieSwitch").is(":checked"), 30);
    createConsentCookie("user_functional_cookie_consent", $("#functionalCookieSwitch").is(":checked"), 30);
    createConsentCookie("user_social_media_cookie_consent", $("#socialmediaCookieSwitch").is(":checked"), 30);

    setGTMConsent();
    setEthiosConsent();
    hideCookieConsent();
    loadUTMParameters();
}

/**
 * Show/hide cookie banner
 */
function showCookieConsent() {
    $("#cookieBox").removeClass("opacity-0 hidden").addClass("show");
}

function hideCookieConsent() {
    $("#cookieBox").removeClass("show").addClass("hidden");
}

/**
 * Dispatch custom GTM events based on cookie consent
 */
function setGTMConsent() {
    const event = getCookie("user_performance_cookie_consent") === "true"
        ? "on_user_performance_cookie_consent_granted"
        : "on_user_performance_cookie_consent_withdrawn";
    document.dispatchEvent(new Event(event));
}

function setEthiosConsent() {
    if (getCookie("user_functional_cookie_consent") === "true") {
        document.dispatchEvent(new Event("on_user_functional_cookie_consent_granted"));
    }
}

/**
 * Create cookie from UTM param if user accepted performance cookies
 */
function loadUTMParameters() {
    if (getCookie("user_performance_cookie_consent") !== "true") return;

    ["utm_source", "utm_term", "utm_campaign", "utm_medium", "utm_content"]
        .forEach(param => {
            const value = getUrlParameter(param);
            if (value) createConsentCookie(param, value, 1);
        });
}

/**
 * Check if script with src exists
 * @param {string} url
 * @returns {boolean}
 */
function isScriptLoaded(url) {
    return Array.from(document.scripts).some(s => s.src === url);
}

/**
 * Toggle switch on enter key
 */
function checkBoxToggle(box) {
    const $box = $(box);
    $box.prop("checked", !$box.prop("checked"));
}

// Consent check on load
function checkConsentCookies() {
    if (getCookie("user_cookie_consent") === "true") {
        hideCookieConsent();
    } else {
        showCookieConsent();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    // Scroll CCPA into view
    if (window.location.href.includes("CCPA")) {
        setTimeout(() => document.getElementById("CCPA")?.scrollIntoView(), 2000);
    }

    checkConsentCookies();
    loadUTMParameters();

    $(document).on("click", "#show-cookie-consent", showCookieConsent);
    $(document).on("click", "#cookie-modal-all-accept, #cookie-banner-close-btn-US, #cookie-accept-btn-intl", addAllConsentCookies);
    $(document).on("click", "#cookie-modal-custom-accept", addCustomConsentCookies);

    $(document).on("keypress", ".cookie-settings-switch", function (e) {
        if (e.keyCode === 13) checkBoxToggle(this);
        e.stopPropagation();
    });
});

// Export for access outside module scope
window.getCookie = getCookie;
window.createConsentCookie = createConsentCookie;
window.loadUTMParameters = loadUTMParameters;